module.exports = new __parcel__URL__("work-items.tpl.4ee9e4f3.svg").toString();